// extracted by mini-css-extract-plugin
module.exports = {"background":"style_background__5Uvde","support":"style_support__SPpqu","title":"style_title___9QXZ","desc":"style_desc__1vDOz"};